export enum UserAccess {
  None = 'None',
  Premium = 'Premium',
  Basic = 'Basic'
}

export enum SalesChannel {
  Sales = 'gx_sales',
  Self = 'self_service'
}

export type UserMetadata = {
  metadataKey: string;
  metadataValue: string;
};

export type UserSubscription = {
  plan: string;
  status: string;
  currentPeriodEnd: string;
  expireAt: string | null;
  trial: boolean;
  salesChannel: SalesChannel | null;
  apiAccess: boolean;
};
